import { Component, OnInit } from '@angular/core';
import { ApiserviceService } from '../core/services/apiservice.service';
import { ActivatedRoute, Route, Router } from '@angular/router';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss']
})
export class PrintComponent implements OnInit {
  onaybekleyen:any[] = [];
  isyerleri:any[] = [];
  ogrenciler:any[] = [];
  yazdirmaalani:any[]=[];
  orders: any[] = [];
  id:any[] = [];
  yaz_isyeri_adi:string;
  yaz_isyeri_tel:string;
  yaz_isyeri_adres:string;
  yaz_usta_adi:string;
  yaz_usta_soyadi:string;
  dataid:string;
  baslik:string;
  duzen_tarih:any;
  ayadi:any;
  eposta:any;
  isletmetel:any;
  isletmeadi:any;

  isyeribul:string;
  ustabul:string;
  pageId:any;
  print:any;
  constructor(private api:ApiserviceService, private rota:ActivatedRoute,private router:Router) { }

  ngOnInit(){
    this.pageId = this.rota.snapshot.paramMap.get('id'); 
    this.print=this.rota.snapshot.paramMap.get('print')
    this.print_data()
  

  }
  print_data(){
    const deger = {
      id: this.pageId
    };
    
    this.isyeribul="";
    this.ustabul="";
    this.api.post('gorev/gorev_bul',deger).then((veri1)=>{
      //this.ogrenciler=veri1.data;
       console.log(veri1.data);
       this.isyeribul=veri1.data[0].isyeri;
       this.ustabul=veri1.data[0].usta;
       this.yaz_isyeri_adi=veri1.data[0].isyeri_adi;
       this.yaz_isyeri_adres=veri1.data[0].adresi;
       this.yaz_isyeri_tel=veri1.data[0].telefon;
       
       this.yaz_usta_adi = veri1.data[0].usta_isim;
       this.yaz_usta_soyadi=veri1.data[0].usta_soyisim;
       
      

       const deger2 = {
        isyeri:this.isyeribul,
        usta:this.ustabul,
      };
      console.log(deger2);
      this.api.post('ogrenci/gorev_ogrenci_bul',deger2).then((veri2)=>{
        this.ogrenciler=veri2.data;
           console.log(veri2.data)
        
           if(this.ogrenciler){
            this.timer()
           }
      })
    })
    
  }
  timer(){
    setTimeout(function(){
      window.print()
      window.onafterprint = back;
      function back() {
      window.history.back();
      }
    }, 2000);  
  }  
     
}
